import { render, staticRenderFns } from "./CrearEditarRelacion.vue?vue&type=template&id=7622a7a2&"
import script from "./CrearEditarRelacion.vue?vue&type=script&lang=js&"
export * from "./CrearEditarRelacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports